import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { BandejaSolicitudesCatalogoPage } from "@/features/bandeja-solicitudes-catalogo/components/BandejaSolicitudesCatalogoPage";
import {
  bandejaSolicitudesCatalogoQueryOptions,
  misTiposResponsableCatalogoQueryOptions,
} from "@/features/bandeja-solicitudes-catalogo/hooks/use-bandeja-solicitudes-catalogo";

/**
 * Ruta `/solicitudes-catalogo` · bandeja de los RESPONSABLES de cada tipo de solicitud de
 * catálogo (por rol · sin permiso fijo). Quien no atiende ningún tipo ve «Acceso restringido».
 */
export const Route = createFileRoute("/_authed-tw/solicitudes-catalogo")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(misTiposResponsableCatalogoQueryOptions),
      queryClient.ensureQueryData(bandejaSolicitudesCatalogoQueryOptions({ estado: "Pendiente", page: 1, pageSize: 15 })),
    ]),
  component: BandejaSolicitudesCatalogoPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
